import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-504717ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chapter"
}
const _hoisted_2 = {
  key: 2,
  class: "iconfont icon-Bookmark- icon-bookmark"
}
const _hoisted_3 = { class: "chapter-name single-line-text-overflow" }
const _hoisted_4 = {
  key: 1,
  class: "chapter-view-list"
}
const _hoisted_5 = {
  key: 2,
  class: "iconfont icon-Bookmark- icon-bookmark"
}
const _hoisted_6 = { class: "chapter-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return ($setup.viewType !== 'list')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode("封面图片"),
        ($setup.blobLink)
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              class: "anim chapter-cover-img",
              src: $setup.blobLink,
              fit: $setup.fit,
              alt: $setup.chapterName
            }, null, 8 /* PROPS */, ["src", "alt"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode("占位图标"),
              _createVNode(_component_el_image, {
                src: $setup.placeholder,
                class: "chapter-cover-img",
                fit: "fill"
              }, null, 8 /* PROPS */, ["src"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
        _createCommentVNode("书签图标"),
        ($props.bookmark)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("章节名称"),
        _createElementVNode("p", _hoisted_3, _toDisplayString($setup.chapterName), 1 /* TEXT */)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createCommentVNode("封面图片"),
        ($setup.blobLink)
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              class: "anim chapter-cover-img",
              src: $setup.blobLink,
              fit: $setup.fit,
              alt: $setup.chapterName
            }, null, 8 /* PROPS */, ["src", "alt"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode("占位图标"),
              _createVNode(_component_el_image, {
                src: $setup.placeholder,
                class: "chapter-cover-img",
                fit: "fill"
              }, null, 8 /* PROPS */, ["src"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
        _createCommentVNode("书签图标"),
        ($props.bookmark)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("章节名称"),
        _createElementVNode("p", _hoisted_6, _toDisplayString($setup.chapterName), 1 /* TEXT */)
      ]))
}